import { render } from "./tour-status.vue?vue&type=template&id=b2f52ebe&scoped=true"
import script from "./tour-status.vue?vue&type=script&lang=js"
export * from "./tour-status.vue?vue&type=script&lang=js"

import "./tour-status.vue?vue&type=style&index=0&id=b2f52ebe&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2f52ebe"]])

export default __exports__